export const CreateAppText = 'Create Your Own Assistant';
export const UpdateAppText = 'Update Your Assistant';
export const ActionsForApp = ['Chat', 'Completion'];
export const AdvancedOptions = ['Show Advanced Control', 'Hide Advanced Control'];
export const DropFiles = 'Drag & drop files or';
export const SupportedFormats = 'Supported formats: PDF, TXT, DOCX, CSV';
export const AppDetailsLabels = [
  'Assistant Name',
  'Assistant Description',
  'LLM Provider',
  'Model',
  'Temperature',
  'Maximum Tokens',
];
export const PromptText = 'Prompt';
export const ResponseText = 'Response';
export const SystemText = 'System Prompt';
export const AddMessageText = 'Add Message';
export const RoleText = 'Role';
export const InputVariablesText = 'Input Variables';
export const ClearAllText = 'Clear All';
export const KeyText = 'Key';
export const ValueText = 'Value';
export const AddInputVariable = 'Add Input Variable';
export const SaveInputText = 'Save Input';
export const SavingText = 'Saving...';
export const RunTestText = 'Run Test';
export const SaveAppText = 'Save as Assistant';
export const UpdateSaveText = 'Update Assistant';
export const NoDataText = 'Data not found!';
export const SaveAppModalTitle = 'Save Assistant';
export const SaveAppModalDesc = 'Save assistant to the system';
export const OptimizeText = 'Optimize';
export const InfoIconDesc =
  'You can add persona, tone, task breakdown and other additional details';
export const PromptHistoryText = 'Prompt History';
export const PromptHistoryTableLabels = ['PREVIOUS PROMPTS', 'LLM', 'TIMESTAMP'];
export const useText = 'Use';
export const piiNote = 'To mask specific PII, add Custom PII below';
export const SelectFolderText = 'Select Folder';
export const KbText = 'Knowledge Base';
